module.exports = __webpack_public_path__ + "img/find-your-tasmanian-partner.f8f76c82.jpg";